import {useSelector} from "react-redux";
import {selectConsent} from "../../../redux/slices/adsSlice";
import {InitializeAds, CreateScope} from "./Utils";
import {useState, useEffect} from "react";
import path from "node:path";

const useGpt = () => {
    const [gptAdsManager, setGptAdsManager] = useState<any>(null);
    const consentValue = useSelector(selectConsent);

    useEffect(() => {
        console.log('Loading gpt...')
        // Initialize Amazon Publisher Services (apstag)
        window.apstag = window.apstag || {
            init: function () {
            },
            fetchBids: function () {
            },
            setDisplayBids: function () {
            },
        };
        window.apstag.init({
            pubID: "",
            adServer: "googletag",
        });

        window.googletag = window.googletag || {cmd: []};

        window.googletag.cmd.push(() => {
            const pubads = window.googletag.pubads()

            pubads.setPrivacySettings({
                restrictDataProcessing: !consentValue,
                nonPersonalizedAds: !consentValue,
            });

            const manager = CreateScope(() => {
                // initializeAds function to setup global gpt settings
                const initializeAdsOnce = (initializeLoading = false, singleRequest = true) => {
                    InitializeAds(initializeLoading, singleRequest, pubads);
                }

                const createSlot = (
                    adPath: string,
                    elementId: string | undefined,
                ) => {
                    // Get the element to determine its dimensions
                    const element = elementId ? document.getElementById(elementId) : null;

                    // Define all possible ad sizes
                    const allSizes = [[320, 100], [300, 250], [336, 280], 'fluid', [320, 50], [468, 60], [728, 90], [750, 200]];
                    // const allSizes = [[336, 280], [320, 100], 'fluid', [300, 250], [320, 50]];
                    let fittingSizes: (number[] | string)[] = [];

                    console.log({element})
                    // If the element exists, create a responsive ad
                    if (element && element.parentNode instanceof HTMLElement) {
                        const parent = element.parentNode;
                        const containerWidth = parent.clientWidth;
                        const containerHeight = parent.clientHeight;
                        console.log(`Parent container dimensions: ${containerWidth}x${containerHeight}`);

                        fittingSizes = allSizes.filter(size => {
                            if (size === 'fluid') return true;
                            if (Array.isArray(size)) {
                                const [width, height] = size;
                                return width <= containerWidth && height <= containerHeight;
                            }
                            return false;
                        });

                        console.log('Requesting ad sizes that fit the parent container:', fittingSizes);
                    } else if (element) {
                        // Fallback to the element's own size if parent is not an HTMLElement
                        const containerWidth = element.clientWidth;
                        const containerHeight = element.clientHeight;
                        fittingSizes = allSizes.filter(size => {
                            if (size === 'fluid') return true;
                            if (Array.isArray(size)) {
                                const [width, height] = size;
                                return width <= containerWidth && height <= containerHeight;
                            }
                            return false;
                        });
                        console.log('Requesting ad sizes that fit the element itself:', fittingSizes);

                    } else {
                        console.warn(`Element with ID '${elementId}' not found.`);
                        return null; // No element, no ad
                    }

                    if (fittingSizes.length === 0) {
                        console.warn(`No ad sizes fit the container for element: ${elementId}`);
                        return null;
                    }

                    const slot = window.googletag.defineSlot(adPath, fittingSizes, elementId);

                    if (!slot) {
                        console.error("Failed to create ad slot for:", adPath, elementId);
                        return null;
                    }

                    slot.addService(pubads);

                    // initializeAdsOnce(false, true);

                    window.googletag.enableServices();
                    return slot;
                };

                return {
                    initializeAds: initializeAdsOnce,
                    createSlot: createSlot,
                };
            });

            setGptAdsManager(manager);
        });

        return () => {
            // Cleanup logic when the component using this hook unmounts.
            window.googletag.cmd.push(() => {
                window.googletag.destroySlots();
            });
        };
    }, []);

    return gptAdsManager;
};
export default useGpt;